export const ballotTypeRecord: Record<string, string> = {
  SR:  'Systematic Review',
  IEC: 'International Electrotechnical Commission',
  CIB: 'Committee Internal Ballot',
  NPB: 'National Project Ballot',
};


